import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'

const ZTransactionHeaderUI = ({context, bankAccountList, onRefreshClick}) =>
  <div className='txn_hdr g_flex_h g_flex_left'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    {
      bankAccountList.map((bankAccount, i) =>
        <TabLinkUI label={bankAccount.bankAccountNumber} key={i}
          active={window.location.pathname.includes(bankAccount.bankAccountNumber)}
          to={`/txns/${bankAccount.bankAccountNumber}`}
        />
      )
    }
  </div>

export default ZTransactionHeaderUI
